module.exports = {
  devices_import_title: "Importar Dispositivos",
  devices_import_cancel: "Cancelar",
  devices_import_save: "Importar",

  devices_import_inventory_location: "Lugar de Inventario",
  devices_import_location: "Lugar",
  devices_import_manufacturer: "Fabricante",
  devices_import_account: "Cuenta",
  devices_import_puls_account: "Puls Account",
  devices_import_shipper_id: "ID del Remitente",
  devices_import_get_devices: "Obtener Dispositivos",

  devices_import_po: "PO",
  devices_import_imei: "IMEI",
  devices_import_serial: "Serial",
  devices_import_iccid: "ICCID",
  devices_import_msisdn: "MSISDN",
  devices_import_serial_imei: "Serial/IMEI",
  devices_import_serial_drid: "Serial/DRID",
  devices_import_valid_serial_8_minlength: "Serial debe contener al menos 8 caracteres",
  devices_import_valid_serial_minlength: "Serial debe contener al menos 3 caracteres",
  devices_import_valid_serial_imei_minlength: "Serial/IMEI debe contener al menos 15 caracteres",
  devices_import_valid_serial_imei_minlength_geo: "Serial/IMEI debe contener 12 caracteres",
  devices_import_valid_serial_imei_minlength_queclink: "Serial/IMEI debe contener 15 caracteres",
  devices_import_valid_serial_drid_minlength: "Serial/DRID debe contener al menos 12 caracteres",
  devices_import_valid_imei_minlength: "IMEI debe contener 15-16 caracteres",
  devices_import_valid_imei_maxlength: "IMEI debe contener 15-16 caracteres",
  devices_import_valid_iccid_minlength: "ICCID debe tener 19-20 caracteres",
  devices_import_valid_iccid_maxlength: "ICCID debe tener 19-20 caracteres",
  devices_import_valid_msisdn_minlength: "Número telefonico debe tener mas de 10 dígitos numéricos",
  devices_import_valid_msisdn_maxlength: "Número telefonico debe ser de max. 15 dígitos numéricos",
  devices_import_valid_duplicated_imei: "El IMEI ya fue añadido previamente",
  devices_import_valid_duplicated_esn: "El Serial ya fue añadido previamente",
  devices_import_valid_duplicated_iccid: "El SIM # ya fue añadido previamente",
  devices_import_valid_duplicated_msisdn: "El Phone # ya fue añadido previamente",

  devices_import_csv_file_instructions_serial: "Debe cargar un archivo CSV con el campo Serial",
  devices_import_order_number: "Número de Orden",
  devices_import_csv_file: "Archivo CSV",
  devices_import_csv_file_instructions: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: Serial",
  devices_import_import_modal_title: "Cargar Dispositivos",
  devices_import_import_modal_content: "¿Esta seguro de cargar los dispositivos?",
  devices_import_import_confirmation_warning: "Alerta, si realiza la importación de dispositivos perdera la información que se encuentra en la grilla",

  devices_import_device_type: "Modelo de Dispositivo",
  devices_import_carrier: "Operador",
  devices_import_purchase_order: "Orden de Compra",
  devices_import_sim: "SIM #",
  devices_import_phone: "Télefono #",

  devices_import_add_new: "Agregar Nuevo",
  devices_import_add_savechanges: "Guardar Cambios",
  devices_import_add_cancelchanges: "Cancelar Cambios",

  devices_import_summary_title: "Dispositivos a Importar",
  devices_import_title: "Agregar Dispositivos",
  devices_import_result_title: "Resultado",
  devices_import_add_succesfuly: "dispositivos agredados exitosamente.",
  devices_import_of: "de",
  devices_import_status: "Estado de Importación",
  devices_import_message: "Mensaje",
  devices_import_import_others: "Importar",
  devices_import_export_others: "Exportar",

  devices_import_csv_file_download_sample: "Descargar Ejemplo",
  devices_import_error_unselected_devices: "Debe seleccionar al menos un dispositivo de la lista",
  devices_import_csv_file_sample_csv: "Ejemplos archivos CSV",

  devices_import_calamp_csv_file_instructions: "Debe cargar un archivo CSV",
  devices_import_device_message: "Mensaje",

  devices_import_invalid_esn: "ESN Inválido",
  devices_import_invalid_imei: "IMEI Inválido",
  devices_import_invalid_device_model: "El número de parte no se encuentra registrado en PM",
  devices_import_device_invalid_purchase_order: "Orden de Compra Inválida",
  devices_import_invalid_serial_drid: "Serial/DRID Inválido",

  devices_import_csv_import: "Importar usando archivo CSV de fabricante",
  devices_import_manual_import: "Importar Manualmente (Sin CSV)",

  devices_import_imei_repeated_in_list: "El dispositivo ya se encuentra en esta lista",
  devices_import_device_search_criteria: "Serial",
  devices_import_device_add: "Agregar",
  devices_import_error_add_devices: "Debe agregar al menos un dispositivo a la lista",

  devices_import_valid_iccid_min: "ICCID debe ser un número positivo",
  devices_import_valid_msisdn_min: "MSISDN debe ser un número positivo",

  devices_import_device_not_found: "Dispositivo no encontrado",
  devices_import_device_unable_to_process: "No se uede procesar la solicitud en este momento. Por favor asegurese que esta ingresando el correcto ESN/IMEI del dispositivo Calamp",
  devices_import_device_not_found_calamp: "el dispositivo con ESN/IMEI no se ha encontrado en el archivo de PULS ",

  devices_import_calamp_errors: "Se encontro los siguientes errores",

  devices_import_get_phone_numbers: "Obtener números de telefonos",

  devices_import_retreving_sim_info: "Obteniendo información de la SIM",
  devices_import_retreving_sim_info_error: "Informacióm de la SIM no encontrada",
  devices_import_load_phone_number_success: "Carga de número de teléfono exitosa",

  devices_import_part_number: "Número de Parte",

  devices_import_service: "Servicio",
  devices_import_ref_number: "# de Referencia",

  devices_import_label: "Etiqueta",
  devices_import_subscription_number: "# de Suscripción",

  devices_import_error_msisdn_missing: "Número de teléfono con una longitud inferior a 10 números",

  devices_import_save_error: "Los dispositivos no se pudieron importar",
  devices_import_message_result: "Mensaje",

  devices_import_message_result_success: "Importado y asignado con éxito",
  devices_import_device_not_found: "Dispositivo no encontrado",

  devices_import_password: "Contraseña",

  devices_import_hardware_version: "Versión del Hardware",
  devices_import_firmware: "Firmware",
  devices_import_sim_state: "Estado de SIM",

  devices_import_error_200: "Error en la contraseña de la cámara",
  devices_import_error_201: "Falló la operación de la cámara",
  devices_import_error_202: "La cámaraa no existe",
  devices_import_error_204: "Error en la syncronización de la cámara",
  devices_import_error_24: "Sin autorización de acceso a la cámara",
  devices_import_error_23: "Fallo en la autenticación",

  devices_import_device_model: "Modelo del Dispositivo",

  devices_import_activate_sim_title: "Activación de SIMS VidFleet",
  devices_import_activate_sim_error_message: "Las SIM Cards VidFleet no pudieron ser activadas",

  devices_import_activate_sims: "Activar tarjetas SIM",

  devices_import_missing_imei_or_serial: "Falta el IMEI o el serial",
  devices_import_file_not_supported: "Archivo no soportado",

  devices_import_unknow_vidfleet_model: "Modelo de dispositivo de VidFleet desconocido",

  devices_import_transaction_request_message:"Se ha recibido la solicitud de importación de dispositivos. Haga clic aquí para ver el estado de la importación.",
  devices_import_click_progress_transaction: "Para ver el progreso de la importación, haga clic aquí.",

  devices_import_csv_file_instructions_queclink: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: IMEI, SIM#, #Teléfono",
  devices_import_csv_file_instructions_pui: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: IMEI, SIM#, #Teléfono",

  devices_import_error_limit_devices: "Solo se pueden importar 300 dispositivos a la vez",

  devices_import_devices_deactiavted_sim: "Hay dispositivos con SIM desactivadas",

  devices_import_sim_provider_account: "Cuenta del Proveedor de la SIM",
  devices_import_reference: "Referencia",

  devices_import_features: "Características",
  devices_import_status: "Estado",

  devices_import_of: "de",
  devices_import_devices_enabled: "dispositivos habilitados",

  devices_import_enable: "Habilitar",
  devices_import_disable: "Deshabilitar",

  devices_import_promiles: "Promiles",
  devices_import_driver_behavior: "Comportamiento del conductor",
  devices_import_ota: "OTA",
  devices_import_sms: "SMS",
  devices_import_starter: "Arrancador",
  devices_import_motion: "Movimiento",
  devices_import_obdii_alerts: "Alerta OBDII",
  devices_import_com_data: "ComData",
  devices_import_pressure_pro: "Presión Profesional",
  devices_import_tow: "Remolque",
  devices_import_ttu: "TTU",

  devices_import_analytics: "Analíticas",
  devices_import_jbus: "JBus",
  devices_import_vbus: "VBus",
  devices_import_battery: "Batería",
  devices_import_hours_enable: "Horas Habilitado",
  devices_import_odometer_enable: "Odómetro Habilitado",
  
  devices_import_device_category_asset: "Activo",
  devices_import_device_category_fleet: "Flota",
  devices_import_apu: "Apu",
  devices_import_hybrid: "Híbrido",
  devices_import_promiles_odometer_calculated: "Odómetro de promiles calculado",
  devices_import_use_ecu_odometer: " Usar odómetro ecu",
  devices_import_use_ecu_engine_hours: "Usar horas de motor ecu",
  devices_import_use_ecu_speed: "Usar velocidad ecu",
  devices_import_use_ecu_vin: "Usar VIN ecu",
  devices_import_show: "Mostrar en la web",

  devices_import_valid_iccid_minlength_general: "Hay dispositivos con ICCID con digitos menores a 19-20 caracteres",
  devices_import_error_msisdn_missing_general: "Hay dispositivos sin números de teléfono o con una longitud inferior a 10 números",
  devices_import_device_repeated_in_list: "Algunos seriales repetidos no fueron adicionados a la lista",

  devices_import_error_devices_selected: "Hay dispositivos seleccionados que presentan errores",
  devices_import_error_devices: "Hay dispositivos que presentan errores",
  devices_import_error_no_devices: "Debe tener al menos un dispositivo en la lista",
  devices_import_linked_mode: "Modo Emparejado",
  devices_import_invalid_puls_customer: "La cuenta calamp no es valida",
  devices_import_camera_mode: "Modo de la Cámara",
  devices_import_camera_gps: "Cámara como GPS",
  devices_import_camera_paired_mode: "Modo Emparejado",

  devices_import_valid_iccid_only_numbers: "El número de teléfono sólo debe contener números",
  devices_import_valid_iccid_only_numbers_general: "Hay dispositivos que contienen letras en el número de teléfono",
  devices_import_valid_msisdn_only_numbers: "El número de teléfono sólo debe contener números",
  devices_import_valid_msisdn_only_numbers_general: "Hay dispositivos que contienen letras en el número de teléfono",
  devices_import_cariq: "Car IQ",
  devices_import_not_cerebrum: " La integración con CerebrumX necesita estar habilitada y 'ACTIVA' para poder importar dispositivos",
  devices_import_csv_file_instructions_cerebrumx: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: VIN, SIM#",
  devices_import_invalid_vin:"VIN Inválido",
  devices_import_invalid_package_name:"Nombre de Paquete Inválido",
  devices_import_vin:"VIN",
  devices_import_package_name: "Nombre del Paquete",
  devices_import_valid_vin_minlength: "VIN debe contener 17 caracteres",
  devices_import_valid_duplicated_vin: "El VIN ya fue añadido previamente",
  devices_import_csv_file_instructions_telitek: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: SERIAL, IMEI, #SIM, #Teléfono",
  devices_import_csv_file_instructions_pacific_track: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: IMEI, #SIM, #Teléfono",
  devices_import_csv_file_instructions_zonar: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: SERIAL",
  devices_import_csv_file_instructions_genx: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: SERIAL, IMEI, #SIM, #Teléfono",
  devices_import_csv_file_instructions_digital_matter: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: IMEI",
  devices_import_not_zonar: "Es necesario agregar la integración de Zonar a la cuenta para poder importar los dispositivos",
  devices_import_zonar_account_id: "ID de cuenta Zonar",
  devices_import_carb: "Carb",
  devices_import_csv_file_instructions_m2md: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: IMEI, ICCID",
  devices_import_csv_file_instructions_smartwitness: "Debe cargar un archivo CSV con los siguentes campos y en el orden siguiente: SERIAL/DRID, ICCID",
}
